export const loginRoute = '/login';
export const loginViaOtpRoute = '/login/otp';
export const forgotPasswordRoute = '/login/forgot-password';
export const vehicleRequestsRoute = '/vehicle-requests';
export const vehicleRequestsMMRoute = '/vehicle-requests-mm';
export const resetPassword = '/login/resetPassword';
export const logoutRoute = '/logout';
export const tripDetailsRoute = '/trip/details/:tripId';
export const istDetailsRoute = '/ist/details/:tripId';
export const consignmentsRoute = '/consignments';
export const analyticsRoute = '/analytics';
export const assignedVehiclesRoute = '/vehicles';
export const assignedDriversRoute = '/workers';
export const moveableAssetsRoute = '/moveable-assets';
export const resetPasswordSideBarRoute = '/vehicle-requests?resetPassword=true';
export const invoicesRoute = '/invoices';
export const receivablesRoute = '/receivables';
export const downloadRequestRoute = '/download-request';
export const userManagementRoute = '/user-management';
